export default {
    header: "Confirme o endereço e envie o pedido",
    message: "O seu endereço de entrega listado abaixo está correto?",
    tip: "Clique <b>em SIM</b> para confirmar o endereço de entrega e enviar o pedido. Clique em <b>NÃO</b> para cancelar o envio e escolher outro endereço.",
    info: "Depois que um pedido é feito, ele não pode ser alterado. Se o produto que você está solicitando estiver em espera ou tiver uma data de envio posterior e você estiver planejando mudar, leve isso em consideração ao escolher o endereço de entrega. Além disso, se houver um feriado ou férias próximos e você não estiver em casa para receber o produto, pedimos que aguarde a realização de qualquer pedido até que esteja em casa para receber os produtos.",
    warning: {
        message: "Verifique novamente se seu {fields} está correto, pois a transportadora pode não conseguir entregar seu pedido ou entrar em contato com você sobre seu pedido. | Verifique novamente se seu {fields} estão corretos, pois a transportadora pode não conseguir entregar seu pedido ou entrar em contato com você sobre seu pedido.",
        name: "Nome",
        street: "Rua",
        phone: "Telefone"
    },
    buttons: {
        yes: "Sim",
        no: "Não"
    }
}